import Vue from 'vue'
import Vuex from 'vuex'
import { getInfo } from '@/api/sqjspx2026'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    account: {
      isLogin: false,
      token: localStorage.getItem('token') || ''
    },
    cart: {
      sidebarOpen: false,
      cartBounce: false,
      toastShow: false,
      toastMessage: '',
      duplicateAlertShow: false,
      duplicateAlertMessage: '',
      items: JSON.parse(localStorage.getItem('cartItems') || '[]')
    }
  },
  mutations: {
    updateLoginState(state, { isLogin }) {
      state.account.isLogin = isLogin
      if (!isLogin) {
        window.location.href = '/login.html'
      }
    },
    logout(state) {
      state.account.isLogin = false
      localStorage.removeItem('token')
      window.location.href = '/login.html'
    },
    login(state, { token }) {
      state.account.isLogin = true
      state.account.token = token
      localStorage.setItem('token', token)
    }
  },
  actions: {
    async checkLogin({ state, commit }) {
      if (!state.account.token) {
        commit('logout')
        return false
      }
      try {
        const response = await getInfo()
        const { data } = response
        if (data) {
          commit('updateLoginState', { isLogin: true })
          return true
        } else {
          commit('updateLoginState', { isLogin: false })
          return false
        }
      } catch (error) {
        commit('updateLoginState', { isLogin: false })
        return false
      }
    }
  }
})

export default store
